export default __webpack_public_path__ + "static/959-7868be333e89d0975f7322b0b206bfc8.gif";